import React from 'react';

import {BuyBackPrice} from './Buyback/BuyBackPrice';
import {IncreasePrice} from './Increase/IncreasePrice';
import Suspense from '@crema/core/Suspense';

const PriceManagement: React.FC = (): React.ReactElement => {
  return (
    <Suspense>
      <BuyBackPrice />
      <IncreasePrice />
    </Suspense>
  );
};

export const priceRouteConfig = [
  {
    routes: [
      {
        path: '/price',
        component: PriceManagement,
      },
    ],
  },
];
